import { render, staticRenderFns } from "./couponManage.vue?vue&type=template&id=2263dc73&scoped=true"
import script from "./couponManage.vue?vue&type=script&lang=js"
export * from "./couponManage.vue?vue&type=script&lang=js"
import style0 from "./couponManage.vue?vue&type=style&index=0&id=2263dc73&prod&lang=scss"
import style1 from "./couponManage.vue?vue&type=style&index=1&id=2263dc73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2263dc73",
  null
  
)

export default component.exports